module.exports = __webpack_public_path__ + "static/media/horizontal_sem_foto_conteudos.44530d18.jpg";